import { TOGGLE_FAVORITE_VOICE } from './types'

export const toggleFavoriteVoice = payload => {
  return { type: TOGGLE_FAVORITE_VOICE, payload }
}
